import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const items = [
  { icon: 'ri-arrow-up-line', key: 'verif_ext_1' },
  { icon: 'ri-palette-line', key: 'verif_ext_2' },
  { icon: 'ri-fire-line', key: 'verif_ext_3' },
  { icon: 'ri-windy-line', key: 'verif_ext_4' },
  { icon: 'ri-plant-line', key: 'verif_ext_5' },
  { icon: 'ri-arrow-down-line', key: 'verif_ext_6' },
];

export default function VerificationsExterieures() {
  const { t } = useTranslation('blogsignes');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="verif-ext" className="scroll-mt-28">
      <h2
        className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-6 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        {t('verif_ext_h2')}
      </h2>

      <p className={`text-slate-primary/70 text-base md:text-lg leading-relaxed mb-6 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('verif_ext_intro')}
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        {items.map((item, idx) => (
          <div
            key={idx}
            className={`flex items-start gap-3 bg-white border border-soft-gray rounded-lg p-4 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: `${idx * 80 + 150}ms` }}
          >
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-copper/10 shrink-0 mt-0.5">
              <i className={`${item.icon} text-copper text-sm`} />
            </div>
            <span className="text-slate-primary/80 text-sm md:text-base">{t(item.key)}</span>
          </div>
        ))}
      </div>

      <div className={`bg-soft-gray rounded-lg p-4 flex items-start gap-3 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-copper/20 shrink-0">
          <i className="ri-lightbulb-line text-copper" />
        </div>
        <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed">{t('verif_ext_conseil')}</p>
      </div>
    </section>
  );
}